import axios from '../utils/axios';

const API_URL = `${process.env.REACT_APP_API_URL}/v1/client`;

const getCampaigns = (clinicId, params = {}) => {
    return axios.get(`${API_URL}/clinics/${clinicId}/campaigns`, { params });
};

const getCampaignById = (clinicId, campaignId) => {
    return axios.get(`${API_URL}/clinics/${clinicId}/campaigns/${campaignId}`);
};

const getCampaignResults = (clinicId, campaignId, params = {}) => {
    return axios.get(`${API_URL}/clinics/${clinicId}/campaigns/${campaignId}/results`, {
        params,
    });
};

const getCampaignResultStats = (clinicId, campaignId) => {
    return axios.get(
        `${API_URL}/clinics/${clinicId}/campaigns/${campaignId}/result-stats`
    );
};

/**
 * Stop a pending blast. Marks campaign ERROR and fails waiting queue rows.
 * PATCH /v1/client/clinics/{clinicId}/campaigns/{campaignId}?status=ERROR
 */
const stopCampaign = (clinicId, campaignId) => {
    return axios.patch(`${API_URL}/clinics/${clinicId}/campaigns/${campaignId}`, null, {
        params: { status: 'ERROR' },
    });
};

/**
 * Launch SMS blast.
 * POST /v1/client/clinics/{clinicId}/sms/blast
 * Expects 202 Accepted while recipients are queued in the background.
 */
const launchSmsBlast = (clinicId, { name, description, message, patientIds }) => {
    return axios.post(`${API_URL}/clinics/${clinicId}/sms/blast`, {
        name,
        description: description || undefined,
        message,
        patientIds,
    });
};

/**
 * Launch email blast.
 * POST /v1/client/clinics/{clinicId}/email/blast
 * Expects 202 Accepted while recipients are queued in the background.
 */
const launchEmailBlast = (clinicId, { name, description, title, htmlContent, jsonContent, patientIds }) => {
    return axios.post(`${API_URL}/clinics/${clinicId}/email/blast`, {
        name,
        description: description || undefined,
        title,
        htmlContent,
        jsonContent: jsonContent || undefined,
        patientIds,
    });
};

const buildCampaignTemplateQuery = ({
    sortBy = 'createdAt',
    sortOrder = 'DESC',
    searchTerm,
    typeFilter,
    activeFilter = 'true',
} = {}) => {
    const parts = [];
    if (sortBy) {
        parts.push(`sortBy==${sortBy}`);
    }
    if (sortOrder) {
        parts.push(`sortOrder==${sortOrder}`);
    }
    if (searchTerm?.trim()) {
        parts.push(`name==*${searchTerm.trim()}*`);
    }
    if (typeFilter) {
        parts.push(`type==${typeFilter}`);
    }
    if (activeFilter === 'true' || activeFilter === true) {
        parts.push('isActive==true');
    }
    if (activeFilter === 'false' || activeFilter === false) {
        parts.push('isActive==false');
    }
    return parts.join(',');
};

/**
 * List campaign templates for the clinic.
 * GET /v1/client/clinics/{clinicId}/campaign-templates
 */
const getTemplates = (clinicId, page = 0, size = 50, queryOptions = {}) => {
    const q = buildCampaignTemplateQuery(queryOptions);
    const params = { page, size };
    if (q) {
        params.q = q;
    }
    return axios.get(`${API_URL}/clinics/${clinicId}/campaign-templates`, { params });
};

/**
 * Get one campaign template (contentPath resolved to HTML for EMAIL templates).
 * GET /v1/client/clinics/{clinicId}/campaign-templates/{templateId}
 */
const getTemplateById = (clinicId, templateId) => {
    return axios.get(`${API_URL}/clinics/${clinicId}/campaign-templates/${templateId}`);
};

export default {
    getCampaigns,
    getCampaignById,
    getCampaignResults,
    getCampaignResultStats,
    stopCampaign,
    launchSmsBlast,
    launchEmailBlast,
    getTemplates,
    getTemplateById,
};
